// The heading bar both pages draw, option C of round 3: the wordmark at the left, which goes
// home; the document's name in the middle; at the right what the page puts there. The Workspace
// passes what keeps the project from taking writes and Close project, the aligner's page its save
// state.

import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { Wordmark } from './Wordmark.tsx'

interface Props {
  /// The wordmark's button: its name, its tooltip as `data-tip` for the shell's tooltip or `title`
  /// where a page has none, and where it goes.
  home: Pick<ButtonHTMLAttributes<HTMLButtonElement>, 'aria-label' | 'title' | 'onClick'> & { 'data-tip'?: string }
  /// A page's own name after the wordmark, inside its button.
  name?: string
  /// The middle, an `h1.doc`.
  title: ReactNode
  /// The right-hand slot.
  right: ReactNode
}

export function TopBar({ home, name, title, right }: Props) {
  return (
    <div className="topbar">
      <button type="button" className="home-mark" id="home-mark" {...home}>
        <Wordmark />
        {name ? <span className="app-name">{name}</span> : null}
      </button>
      {title}
      <div className="right">{right}</div>
    </div>
  )
}
